import moment from "moment";

export type ExpirationStatus = "expired" | "warning" | "valid";

export type Expiration = {
  status: ExpirationStatus;
  daysLeft: number; // negativo si ya ha vencido
  formatted: string; // DD/MM/YYYY
};

/**
 * Estado de una fecha de vencimiento respecto a hoy:
 * - "expired": anterior a hoy
 * - "warning": hoy o dentro de los días de aviso del elemento (advise_days)
 * - "valid": posterior
 * Sin días de aviso (vacío o 0) no hay estado de aviso: vigente hasta que vence.
 * Devuelve null si no hay fecha o no es válida.
 */
export const getExpiration = (date: any, adviseDays?: any): Expiration | null => {
  if (date === null || date === undefined || String(date).trim() === "") return null;
  const expiration = moment(date);
  if (!expiration.isValid()) return null;

  const daysLeft = expiration.clone().startOf("day").diff(moment().startOf("day"), "days");
  const warningDays = Number(adviseDays);
  const hasWarning = Number.isFinite(warningDays) && warningDays > 0;
  const status: ExpirationStatus =
    daysLeft < 0 ? "expired" : hasWarning && daysLeft <= warningDays ? "warning" : "valid";

  return { status, daysLeft, formatted: expiration.format("DD/MM/YYYY") };
};

export const describeExpiration = ({ status, daysLeft }: Expiration): string => {
  if (status === "expired") {
    const days = Math.abs(daysLeft);
    return `Vencida hace ${days} ${days === 1 ? "día" : "días"}`;
  }
  if (daysLeft === 0) return "Vence hoy";
  return `Vence en ${daysLeft} ${daysLeft === 1 ? "día" : "días"}`;
};
